import { ContractorNew } from '../types';

export const MOCK_CONTRACTORS: readonly ContractorNew[] = [
  {
    id: '1',
    name: 'ООО "Айчурек Компани"',
    phone: '+996 555 123 456',
    address: 'г. Бишкек, ул. Чуй 156',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '2',
    name: 'ИП "Кылыч Насыров"',
    phone: '+996 772 987 654',
    address: 'г. Ош, ул. Ленина 45',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '3',
    name: 'ТОО "Алтын Продукт"',
    phone: '+996 558 555 777',
    address: 'г. Бишкек, пр. Манас 89',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '4',
    name: 'ОАО "Кыргыз Нан"',
    phone: '+996 312 456 789',
    address: 'г. Бишкек, ул. Токтогула 210',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  }
] as const;
